export const questionnaireConstants = {
  QUESTIONNAIRES_REQUEST: 'QUESTIONNAIRES_REQUEST',
  QUESTIONNAIRES_SUCCESS: 'QUESTIONNAIRES_SUCCESS'
}
